import React, { useEffect, useRef, useState } from 'react';
import { Trophy, Star, Award, Target } from 'lucide-react';
import { careerTimeline } from '../data/mockData';
import '../styles/journey.css';

const JourneyTimeline = () => {
  const [visibleItems, setVisibleItems] = useState(new Set());
  const timelineRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.dataset.index);
          if (entry.isIntersecting) {
            setVisibleItems((prev) => new Set([...prev, index]));
          } else {
            // Remove from visible when scrolling away
            setVisibleItems((prev) => {
              const newSet = new Set(prev);
              newSet.delete(index);
              return newSet;
            });
          }
        });
      },
      { 
        threshold: 0.3,
        rootMargin: '-50px'
      }
    );

    const items = timelineRef.current?.querySelectorAll('.timeline-item');
    items?.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const getIcon = (iconName) => {
    const icons = {
      trophy: <Trophy size={24} />,
      star: <Star size={24} />,
      award: <Award size={24} />,
      target: <Target size={24} />
    };
    return icons[iconName] || <Trophy size={24} />;
  };

  return (
    <section id="journey" className="journey-section">
      <div className="container">
        <div className="journey-header">
          <div className="section-label">
            <span>Career Journey</span>
          </div>
          <h2 className="section-title">
            A <span className="text-highlight">Championship</span> Career
          </h2>
          <p className="journey-subtitle">
            From debut to dominance - witness the journey of a Karnataka cricket champion
          </p>
        </div>

        <div className="timeline-wrapper" ref={timelineRef}>
          <div className="timeline-line"></div>
          
          {careerTimeline.map((item, index) => (
            <div
              key={index}
              className={`timeline-item ${visibleItems.has(index) ? 'visible' : ''} ${
                index % 2 === 0 ? 'left' : 'right'
              }`}
              data-index={index}
            >
              <div className="timeline-content">
                <div className="timeline-year">{item.year}</div>
                <div className="timeline-card">
                  <div className="timeline-icon">{getIcon(item.icon)}</div>
                  <h3 className="timeline-title">{item.title}</h3>
                  <div className="timeline-achievement">{item.achievement}</div>
                  <p className="timeline-description">{item.description}</p>
                  <div className="timeline-stats">{item.stats}</div>
                </div>
              </div>
              <div className="timeline-marker"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JourneyTimeline;
